import { Component, ChangeDetectionStrategy } from '@angular/core';

import { Router } from '@angular/router';

type BlogItem = {
    id: string;
    link: string;
    author: string;
    summary: string;
    imagePath: string; // e.g., '/assets/images/blogs/horse.jpg'
    publishedAt: string; // ISO string, e.g., '2024-07-24T18:27:00Z'
};

@Component({
    selector: 'app-resource',
    imports: [],
    templateUrl: './resources.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class resourceComponent {
    constructor(private router: Router) {}

    // Simulated JSON response (replace with service call as needed)
    readonly blogs: BlogItem[] = [
        {
            id: 'b1',
            link: 'https://ukhsa.blog.gov.uk/2019/02/14/health-matters-preventing-cardiovascular-disease/   ',
            author: 'Jamie Waterall',
            summary: 'Health Matters: Preventing cardiovascular disease',
            imagePath: '../assets/images/resources/blog1.jpg',
            publishedAt: '2019-02-14T10:45:00Z'
        },
        {
            id: 'b2',
            link: 'https://www.heart.org/en/news/2024/06/04/heart-disease-and-stroke-could-affect-at-least-60-percent-of-adults-in-us-by-2050',
            author: 'American Heart Association News',
            summary: 'Heart disease and stroke could affect at least 60% of adults in U.S. by 2050',
            imagePath: '../assets/images/resources/blog2.jpg',
            publishedAt: '2024-07-28T10:45:00Z'
        },
        {
            id: 'b3',
            link: 'https://heartpractice.sg/cardiovascular-risk-factors-among-singaporeans/',
            author: 'Heart Practise',
            summary: 'Cardiovascular Risk Factors Among Singaporeans',
            imagePath: '../assets/images/resources/blog3.jpg',
            publishedAt: '2025-09-28T08:32:00Z'
        },
        {
            id: 'b4',
            link: 'https://www.myheart.org.sg/health/heart-disease-statistics/',
            author: 'World Health Organisation',
            summary: 'Heart Disease Statistics - Singapore',
            imagePath: '../assets/images/resources/blog4.jpg',
            publishedAt: '2024-07-30T08:32:00Z'
        },
        {
            id: 'b5',
            link: 'https://www.channelnewsasia.com/singapore/heart-attacks-disease-rise-younger-people-risk-factors-5143436',
            author: 'Channel News Asia',
            summary: 'Heart attacks remain on the rise in Singapore',
            imagePath: '../assets/images/resources/blog5.png',
            publishedAt: '2024-08-03T11:56:00Z'
        }
    ];

    get totalLabel(): string {
        return `${this.blogs.length} Blogs`;
    }

    // Format: 24,Jul 2024 - 18:27
    formatDate(iso: string): string {
        const d = new Date(iso);
        const day = d.getDate();
        const month = d.toLocaleString('en-US', { month: 'short' });
        const year = d.getFullYear();
        const hh = String(d.getHours()).padStart(2, '0');
        const mm = String(d.getMinutes()).padStart(2, '0');
        return `${day},${month} ${year} - ${hh}:${mm}`;
    }

    // Optional click handler for a blog
    openBlog(item: BlogItem): void {
        const href = item.link?.trim();
        if (!href) return;
        if (/^https?:\/\//i.test(href)) {
            window.open(href, '_blank', 'noopener');
        } else {
            this.router.navigate([href]);
        }
    }
    trackByBlogId = (_: number, item: { id: string }) => item.id;
}
